import { getPropsFromRoute } from '@/router/router-utils';
import { Route } from 'vue-router';
import APIService from '@/api';
import store from '@/store';
import eventBus from '@/utils/eventBus';
import ModalOptions from '@/components/Modal/ModalOptions';
import { IRouterProps } from '@/router/interfaces/router-props.interface';

class JwtVerification {
  initialize(from: Route, to: Route) {
    store.watch(
      (s, getters) => getters['business/getBusinessState'],
      businessData => this.verifyIfPossible(from, to, businessData)
    );
  }

  private verifyIfPossible(from: Route, to: Route, business: any) {
    const props = getPropsFromRoute(to);
    const managerJWTDecoded = APIService.getManagerJWTDecoded();

    if (
      this.isManagerAndHasABusiness(props, business) &&
      this.isNotImpersonated() &&
      this.isNotAtOnboarding(from, to) &&
      managerJWTDecoded
    ) {
      this.verify(business, managerJWTDecoded);
    }
  }

  private verify(business: any, managerFromJWT: any) {
    const managerFromBusiness = business.manager;

    const managerHasChanged =
      managerFromJWT.sub !== (managerFromBusiness && managerFromBusiness.id);
    const businessHasChanged =
      managerFromJWT.extraInfo.business.id !== business.id;

    if (managerHasChanged || businessHasChanged) {
      eventBus.$emit(
        'openModal',
        new ModalOptions(
          `Oops!`,
          `
          It looks like you opened another session in a new tab.\nClick on the button to reload this page
          `,
          'warning',
          true,
          `Ok`,
          ``,
          'reloadPage',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          true
        )
      );
      return;
    }
  }

  private isNotImpersonated() {
    return !store.getters['manager/isImpersonated'];
  }

  private isManagerAndHasABusiness(props: IRouterProps, business: any) {
    return (
      props.auth === 'manager' &&
      props.routeRequirements.managerHaveBusiness &&
      typeof business === 'object' &&
      !!Object.keys(business).length
    );
  }

  private isNotAtOnboarding(from: Route, to: Route) {
    return from.name !== 'onboarding' && to.name !== 'onboarding';
  }
}

export default new JwtVerification();
